import React from "react";
import styles from "./Header.module.css";
import { useStateContext } from "../../lib/StateContext";
import { round } from "../../lib/utils";

function Header({ className }) {
  const [state] = useStateContext();

  const age = React.useMemo(() => {
    return 13;
  }, []);

  const totalMoney = React.useMemo(() => {
    return Object.keys(state.monies).reduce((acc, key) => {
      return acc + state.monies[key];
    }, 0);
  }, [state]);

  const name = React.useMemo(() => {
    return state.player.name;
  }, [state]);

  return (
    <header className={`${className} ${styles.container}`}>
      <div>Net Worth: $ {round(totalMoney)}</div>
      <div>Age: {age}</div>
      <div>{name}</div>
    </header>
  );
}

export default Header;
